export const getCleanQuery = (query: string) =>
  query ? query.trim().toLowerCase() : '';
